import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {AttachedDocument} from '../documents';
import {formattedTimestampDate} from 'shared/tools';
import _ from 'lodash';

class PublicOffer extends DomainObject {
  renderedContent;
  locale;
  companyName;
  companyLogo;
  firstName;
  lastName;
  email;
  expiresAt;
  offerVersion;
  isAccepted;
  acceptable;
  attachments;

  _relations = {
    _dates: ['expiresAt'],
    attachments: [AttachedDocument]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      renderedContent: observable,
      locale: observable,
      companyName: observable,
      companyLogo: observable,
      firstName: observable,
      lastName: observable,
      email: observable,
      expiresAt: observable,
      offerVersion: observable,
      isAccepted: observable,
      acceptable: observable,
      attachments: observable,
      logoUrl: computed,
      expiresAtDate: computed
    });

    this.merge(other);
  }

  get logoUrl() {
    return _.get(this, 'links.companyLogo');
  }

  get expiresAtDate() {
    return formattedTimestampDate(this.expiresAt);
  }

  renderedContentWithSignature(signatureData) {
    if (!signatureData) {
      return this.renderedContent;
    }

    return this.renderedContent.replace(
      /(<img[^>]*alt="Signature"[^>]*\/?>)/gi,
      '<img src="' + signatureData + '" alt="" class="absolute" style="left: 0; width: 100%;"/>' + '$1'
    );
  }
}

export default PublicOffer;
